import { JSX } from "react";

import { Outlet } from "react-router-dom";

function ShopRegionDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default ShopRegionDashboardPage;
